export default __webpack_public_path__ + "static/media/edit_circle_gray.d429d6e5.svg";